import { useNavigate } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center ss-fadein" data-testid="payment-cancel-view">
        <div className="w-16 h-16 mx-auto rounded-3xl bg-slate-50 border border-slate-200 flex items-center justify-center">
          <XCircle className="w-9 h-9 text-slate-400" />
        </div>
        <h1 className="mt-6 text-3xl font-extrabold tracking-tight text-slate-900">Płatność anulowana</h1>
        <p className="mt-2 text-slate-500">Nic się nie stało. Możesz wybrać plan kiedy tylko chcesz.</p>
        <button
          data-testid="cancel-back-button"
          onClick={() => navigate("/", { replace: true })}
          className="mt-8 inline-flex items-center gap-2 bg-[#FFD600] hover:bg-[#E6C200] text-slate-900 font-bold px-6 py-3.5 rounded-2xl btn-yellow-glow"
        >
          Wróć do aplikacji <ArrowRight className="w-4 h-4" strokeWidth={2.5} />
        </button>
      </div>
    </div>
  );
}
